import DatePicker from 'vue2-datepicker'

export default {
  DatePicker
}



// WEBPACK FOOTER //
// ./src/app/dweller/access/resources/components.js